<h3-right-collapsing-panel>
  <div class="menu-bar" projection-location="menu-bar">
    <a
      (click)="closeFilterEditor()"
      class="btn btn-default btn-xs close-button"
    >
      <fa-icon [icon]="faArrowLeft" [fixedWidth]="true"></fa-icon>
    </a>
  </div>
  <div class="layout-grid">
    <div class="filter-container" h3ScrollEnabler>
      <div class="content" *ngFor="let filtersByOutput of filtersByOutputs">
        <div class="label-grid">
          <div class="line"></div>
          <div class="label-text">{{ filtersByOutput.outputLabel }}</div>
        </div>
        <h3-checkbox
          *ngFor="let filter of filtersByOutput.filters"
          [formControl]="filter.formControl"
          (change)="trackFilterChange()"
          >{{ filter.filterLabel }}</h3-checkbox
        >
      </div>
    </div>
    <div class="panel-footer text-center">
      <button class="btn btn-default filter-btn" (click)="clearFilters()">
        Hide all
      </button>
      <button class="btn btn-default filter-btn" (click)="resetFilters()">
        Show all
      </button>
    </div>
  </div>
</h3-right-collapsing-panel>
